import { render, staticRenderFns } from "./LabelSetSamples.vue?vue&type=template&id=6d4aa956&"
import script from "./LabelSetSamples.vue?vue&type=script&lang=js&"
export * from "./LabelSetSamples.vue?vue&type=script&lang=js&"
import style0 from "./LabelSetSamples.vue?vue&type=style&index=0&id=6d4aa956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports